export default "__VITE_ASSET__d49c0de9__"